import { useCallback } from "react";

import { ICON_SIZE } from "@/config/constants";

import { TrashSimpleIcon } from "@phosphor-icons/react";
import { TagAction } from "../types";
import { FetchedTag } from "@/services/api/fetchers/tags";

interface UseTagActionsProps {
  deleteTag: (tag: FetchedTag) => void;
}

export function useTagActions({ deleteTag }: UseTagActionsProps) {
  const actions = useCallback(
    (tag: FetchedTag) => {
      const actions: TagAction[] = [
        {
          icon: <TrashSimpleIcon size={ICON_SIZE.md} />,
          key: "delete",
          label: "Delete",
          run: () => deleteTag(tag),
        },
      ];

      return actions;
    },
    [deleteTag]
  );

  return actions;
}
